import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import { nextVisitsPageAction, prevVisitsPageAction, setVisitsPageSizeAction } from '../../redux/actions/visitsActions';

const VisitsPagination = () => {
  const pageable = useSelector((state) => state.visits?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextVisitsPageAction}
      onPrevPageClickAction={prevVisitsPageAction}
      onPageSizeChangeAction={setVisitsPageSizeAction}
    />
  );
};

export default VisitsPagination;
